import { loadImage } from 'canvas'
import { fabric } from '~/utils/editor/fabric'
import { ActualVersion } from '~/utils/editor/versioning/image'

export const loadImageAndConvertToPng = async (imageUrl: string): Promise<HTMLImageElement> => {
  if (process.server) {
    const response = await fetch(imageUrl)

    if (!response.ok) {
      return Promise.reject('Не удалось загрузить изображение')
    }

    const imageBlob = await response.blob()
    const arrayBuffer = await imageBlob.arrayBuffer()

    let buffer: Buffer = Buffer.from(arrayBuffer)
    // if (/\.webp($|\?)/i.test(imageUrl)) {
    const sharp = await import('sharp')
    buffer = await sharp.default(buffer, { failOn: 'warning' }).png().toBuffer()
    // }
    return new Promise((resolve, reject) => {
      loadImage(buffer)
        .then((image) => {
          resolve(image as unknown as HTMLImageElement)
        })
        .catch((e) => {
          reject(e ?? 'Loading image failed')
        })
    })
  }

  if (process.client && window.location.host !== (new URL(imageUrl)).hostname) {
    const response = await fetch(imageUrl)
    const imageBlob = await response.blob()
    const arrayBuffer = await imageBlob.arrayBuffer()
    const buffer: Buffer = Buffer.from(arrayBuffer)
    imageUrl = `data:${imageBlob.type};base64,${buffer.toString('base64')}`
  }

  return new Promise((resolve, reject) => {
    fabric.util.loadImage(imageUrl)
      .then((image) => {
        resolve(image)
      })
      .catch((e) => {
        reject(e ?? 'Loading image failed')
      })
  })
}

export const createBrokenImagePlug = async (object: ActualVersion): Promise<string> => {
  return new Promise((resolve) => {
    const cropWidth = object.cropWidth ?? 0
    const cropHeight = object.cropHeight ?? 0
    const offsetX = object.offsetX ?? 0
    const offsetY = object.offsetY ?? 0
    const borderWidth = 2 / Math.max((object.width ?? 0) / cropWidth, (object.height ?? 0) / cropHeight)
    const realWidth = cropWidth - offsetX
    const realHeidht = cropHeight - offsetY
    const fakeCanvas = new fabric.StaticCanvas(undefined, {
      enableRetinaScaling: false,
      width: realWidth,
      height: realHeidht,
    })
    const rect = new fabric.Rect({
      width: cropWidth - borderWidth,
      height: cropHeight - borderWidth,
      stroke: '#6610f2',
      strokeWidth: borderWidth,
      fill: undefined,
    })
    fakeCanvas.add(rect)
    rect.set({
      left: -offsetX,
      top: -offsetY,
    })
    rect.setCoords()
    const dataURL = fakeCanvas.toDataURL({
      width: realWidth,
      height: realHeidht,
      left: 0,
      top: 0,
      format: 'png',
      multiplier: 1,
    })
    resolve(dataURL)
  })
}
